<template>    
        <button 
            type="button" 
            :id="id" 
            class="btn border bg-gray-5 btn-sm btn-block"
            @click.prevent="action">
                <span class="small">{{ description }}</span>
                <img 
                    :src="src" 
                    height="20" 
                    class="float-right"/>
        </button>    
</template>

<script>
    export default {
        name : 'BaseButtonSSO',
        props : {
            id : String,
            description : String,
            src : String,
            click : Function
        },
        methods : {
            action : function(){
                this.click();
            }
        }
    }
</script>
<style>
    
</style>